import React from 'react'
import {shift, useFloating, useInteractions, useFocus, useHover} from '@floating-ui/react'
import {styled} from '@mui/material/styles'
import icon from '../../stories/assets/icons/question_mark.svg'

const CircleButton = styled('img')(({theme, overviewSection}) => ({
	cursor: 'pointer',
	marginLeft: overviewSection ? '0.5vw' : '5px',
	marginTop: overviewSection ? '0' : '10px',
	placeSelf: overviewSection ? 'unset' : 'flex-start',
	width: overviewSection ? '27px' : 'auto',
	minWidth: overviewSection ? '27px' : 'auto',
	maxWidth: overviewSection ? '27px' : 'auto',
	borderLeft: 'none',
	paddingLeft: '0px',
	[theme.breakpoints.down('md')]: {
		width: overviewSection ? '22px' : 'auto',
		maxWidth: overviewSection ? '22px' : 'auto',
		minWidth: overviewSection ? '22px' : 'auto'
	}
}))

const ToolTipContainer = styled('div')(({theme}) => ({
	maxWidth: '240px',
	color: 'rgb(255, 255, 255)',
	backgroundColor: 'rgba(9, 42, 72, 0.9)',
	whiteSpace: 'normal',
	display: 'inline-block',
	fontSize: '0.875rem',
	boxShadow: theme.shadows[1],
	padding: theme.spacing(1),
	borderRadius: theme.shape.borderRadius,
	zIndex: 9999
}))

export default function Popover({htmlContent, content, overviewSection}) {

	const [isOpen, setIsOpen] = React.useState(false)

	const {refs, context, floatingStyles} = useFloating({
		open: isOpen,
		onOpenChange: setIsOpen,
		middleware: [shift()]
	})
	const hover = useHover(context)
	const {getReferenceProps, getFloatingProps} = useInteractions([
		hover,
		focus,
	])

	return <>
		<CircleButton
			src={icon}
			alt="disclaimer"
			overviewSection={overviewSection}
			ref={refs.setReference}
		/>
		{isOpen && (
			<ToolTipContainer ref={refs.setFloating} style={floatingStyles}>{htmlContent || content}</ToolTipContainer>
		)}
	</>

}